
import { getCountryFlag, getCountryName } from '@/utils/countries';

interface TutorCountryFlagProps {
  countryCode?: string;
  showName?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const TutorCountryFlag = ({ 
  countryCode, 
  showName = false, 
  size = 'md',
  className = ''
}: TutorCountryFlagProps) => {
  if (!countryCode) return null;

  const flag = getCountryFlag(countryCode);
  const name = getCountryName(countryCode);

  if (!flag) return null;

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <span className={sizeClasses[size]} title={name}>
        {flag}
      </span>
      {showName && (
        <span className="text-xs text-foreground/80 font-medium truncate">
          {name}
        </span>
      )}
    </div>
  );
};

export default TutorCountryFlag;
